
import notification from './notification';

const manageUser = {notification };

export default manageUser;